import { ToastrService } from 'ngx-toastr';

import { Injectable } from '@angular/core';

import { ViAlprExportToastComponent } from '@lib/toasts/components/vi-alpr-export-toast/vi-alpr-export-toast.component';

import { LprExport } from '../../../api/models/lpr-export.model';
import { LprExportStatus } from '../../../models/alpr-export-status.enum';
import { LPR_EXPORT_TOAST_TIMEOUT } from '../../../utils/constants/lpr-export.constants';

@Injectable({
  providedIn: 'root',
})
export class ViLprExportService {
  constructor(private readonly _toastrService: ToastrService) {}

  public handleAlprExportStatusMessage(data: LprExport): void {
    if (!data) {
      return;
    }

    if (data.status === LprExportStatus.COMPLETE || data.status === LprExportStatus.FAILED) {
      this._toastrService.show('', '', {
        toastComponent: ViAlprExportToastComponent,
        extendedTimeOut: LPR_EXPORT_TOAST_TIMEOUT,
        tapToDismiss: false,
        toastClass: 'vi-alpr-export-toast',
        payload: data.status,
      });
    }
  }
}
